import { startRecorderSaga } from 'features/recorder/sagas/startRecorderSaga';
import { call, select } from 'redux-saga/effects';
import { selectIsRecorderSession } from 'features/recorder/recorderSlice';
import { selectIsRestreamerSession } from 'features/restreamer/restreamerSlice';
import { startRestreamerSaga } from 'features/restreamer/sagas/startRestreamerSaga';

export function* handleSystemSessionSaga() {
  const isRecorder: boolean = yield select(selectIsRecorderSession);
  if (isRecorder) {
    yield call(startRecorderSaga);

    return;
  }

  const isRestreamer: boolean = yield select(selectIsRestreamerSession);
  if (isRestreamer) {
    yield call(startRestreamerSaga);
  }
}
